module.exports = __webpack_public_path__ + "static/media/about_02.4c7c5894.jpg";